import { useEffect, useState } from 'react';
const COMPUTER_ONBOARDING_CARDS_MIN_VIEWPORT_HEIGHT = 740;
export const useShowPageBottomUpsellInViewport = ({ inputRef, maxAskInputRatio, }) => {
    const [canShowInViewport, setCanShowInViewport] = useState(false);
    useEffect(() => {
        const el = inputRef.current;
        const check = () => {
            const viewportHeight = window.innerHeight;
            const isTallEnough = viewportHeight >= COMPUTER_ONBOARDING_CARDS_MIN_VIEWPORT_HEIGHT;
            const isInputWithinBounds = el ? el.offsetHeight / viewportHeight <= maxAskInputRatio : true;
            setCanShowInViewport((prev) => {
                const next = isTallEnough && isInputWithinBounds;
                return prev === next ? prev : next;
            });
        };
        check();
        const resizeObserver = el ? new ResizeObserver(check) : null;
        if (el)
            resizeObserver?.observe(el);
        window.addEventListener('resize', check);
        return () => {
            resizeObserver?.disconnect();
            window.removeEventListener('resize', check);
        };
    }, [inputRef, maxAskInputRatio]);
    return { canShowInViewport };
};
//# sourceMappingURL=useShowPageBottomUpsellInViewport.js.map